import { useId } from "react";

/**
 * DiningMate brand mark: white fork + rounded "D" on a rounded orange-gradient tile.
 * Self-contained SVG (tile + gradient + glyph) — drop it in wherever the logo icon is needed.
 * Keep the artwork in sync with public/brand-mark.svg.
 */
export const BrandMark = ({ size = 28 }: { size?: number }): JSX.Element => {
    const gradientId = useId();

    return (
        <svg
            width={size}
            height={size}
            viewBox="204 186 846 858"
            fill="none"
            role="img"
            aria-label="DiningMate"
            focusable="false"
        >
            <defs>
                <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stopColor="#ff9f08" />
                    <stop offset="0.48" stopColor="#ff7604" />
                    <stop offset="1" stopColor="#f13c0b" />
                </linearGradient>
            </defs>

            <path
                fill={`url(#${gradientId})`}
                d="M 448 186 C 313 186 204 295 204 430 L 204 800 C 204 935 313 1044 448 1044 L 807 1044 C 942 1044 1050 935 1050 800 L 1050 430 C 1050 295 942 186 807 186 Z"
            />

            <g fill="#fff">
                <path d="M 377.5 364 C 382.5 366 386 371 386 377 L 386 522 L 369 522 L 369 377 C 369 371 372.5 366 377.5 364 Z" />
                <path d="M 416.5 364 C 421.5 366 425 371 425 377 L 425 522 L 408 522 L 408 377 C 408 371 411.5 366 416.5 364 Z" />
                <path d="M 455.5 364 C 460.5 366 464 371 464 377 L 464 522 L 447 522 L 447 377 C 447 371 450.5 366 455.5 364 Z" />
                <path d="M 494.5 364 C 499.5 366 503 371 503 377 L 503 522 L 486 522 L 486 377 C 486 371 489.5 366 494.5 364 Z" />
                <path d="M 369 508 C 369 552 382 581 405 603 C 413 609 416 616 415 628 L 399 833 C 397 853 411 868 431 868 C 451 868 466 853 464 833 L 453 628 C 452 616 456 609 464 603 C 489 580 503 551 503 508 L 503 508 Z" />
                <path
                    transform="translate(0 867) scale(1 1.077) translate(0 -867)"
                    d="M 614 399 L 687 399 C 817 399 921 502 921 633 C 921 763 817 867 687 867 L 614 867 C 588 867 567 846 567 820 L 567 544 L 670 544 L 670 770 L 687 770 C 760 770 817 711 817 633 C 817 555 760 490 687 490 L 614 490 C 588 490 567 470 567 444 C 567 419 588 399 614 399 Z"
                />
            </g>
        </svg>
    );
};

export default BrandMark;
